/*
*  This directive formats the model value for the view only. It does not go the other way.
*
 */

import { Directive, ElementRef, HostListener, Inject } from "@angular/core";

@Directive({
    selector: '[blank-when-zero]',
})
export class BlankWhenZeroDirective {

    constructor(@Inject(ElementRef) private $el: ElementRef) {}

    @HostListener('input', ['$event']) onInputChange(event) {
        const initialValue = this.$el.nativeElement.value;
        const formatedValue = this.formatInput(initialValue);
        if (initialValue !== formatedValue) {
            this.$el.nativeElement.value = formatedValue;
        }
    }

    private formatInput(valueToFormat: string) {

        if(valueToFormat) {
            const number = Number(valueToFormat)
            if (number === 0) {
                return '';
            }
        }

        return valueToFormat;

    }
}
